import React, { lazy, Suspense } from 'react';
import { MSlotProps } from './MSlot.types';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { AEMReactCompMapByPath } from '../../utils/AEMReactCompMapUtil';
import clsx from 'clsx';

/**
 * @description This renders a Generic parsys component
 * @returns {React.ReactElement}
 */
export const MSlot: React.FC<MSlotProps> = props => {
  const {
    pagePath,
    itemPath,
    isAuthorMode = false,
    cqItems = {},
    allowedComponents = [],
    className = '',
    containerClassName = '',
    model,
  } = props;

  if (isAuthorMode) {
    return (
      <div className={clsx('m-slot', containerClassName)} data-test={JSON.stringify({ pagePath, itemPath })}>
        <div className={className}>
          <ResponsiveGrid
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            pagePath={pagePath}
            itemPath={itemPath}
            columnCount="12"
            gridClassNames={''}
            config={{
              isEmpty: () => true,
              resourceType: 'mi-aem-common-spa/components/container',
            }}
          />
        </div>
      </div>
    );
  }

  // In non-author mode, dynamically import and render components
  const mapper = AEMReactCompMapByPath(allowedComponents);

  const renderComponents = () => {
    const components: React.ReactNode[] = [];

    const itemOrder = model?.[':order'] || Object.keys(cqItems);

    itemOrder.forEach((itemKey: string) => {
      if (!cqItems[itemKey]) return;

      const item = cqItems[itemKey];
      const itemType = item[':type']?.split('/').pop();

      if (!itemType || !mapper[itemType]) return;

      const componentName = mapper[itemType];
      const Component = lazy(() =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        import(`../../index`).then((module: any) => ({
          default: module[componentName],
        }))
      );

      components.push(
        <Suspense key={itemKey} fallback={<div className="m-slot__loading">Loading...</div>}>
          <Component {...item} />
        </Suspense>
      );
    });

    return components;
  };

  return (
    <div className={clsx('m-slot', containerClassName)} data-test={JSON.stringify({ pagePath, itemPath })}>
      <div className={className}>{renderComponents()}</div>
    </div>
  );
};

export default MSlot;
